import React from "react";
import usePermissions from "../../utils/usePermissions";

const UserPrivateComponent = ({ permission, altPermission, children, comment, type }) => {
  const { permissions, hasPermission } = usePermissions();

  // Check if user has permission (handles string or array)
  // If permission is an array, we assume 'or' logic for access (any of the permissions)
  const isAllowed =
    (permission && hasPermission ? hasPermission(permission, "or") : permissions?.includes(permission)) ||
    (altPermission && hasPermission ? hasPermission(altPermission, "or") : permissions?.includes(altPermission));

  if (isAllowed) {
    return <>{children}</>;
  } else {
    if (type === "update") {
      return (
        <div className="p-4 flex justify-center items-center min-h-[300px] w-[550px] mx-auto">
          <h1 className="text-lg text-gray-500 font-semibold">
            {comment || "You don't have permission to update this action"}
          </h1>
        </div>
      );
    } else {
      return "";
    }
  }
};

export default UserPrivateComponent;
